import React from 'react';
import { useTranslation } from 'react-i18next';

// assets
import GreenCheckIcon from 'shared/assets/green-check.svg?react';

// styles
import * as Styled from 'appExplainers/styles/AboutPage.style';
import * as Text from 'theme/components/Text.style';

function IntroCard(): JSX.Element {
  const { t } = useTranslation('pageAbout');

  const instructionRows = [
    t('intro.instruction1'),
    t('intro.instruction2'),
    t('intro.instruction3'),
  ];

  const getRow = (row: string, key: number): JSX.Element => (
    <Styled.InstructionRow key={key}>
      <GreenCheckIcon />
      <Text.P2>{row}</Text.P2>
    </Styled.InstructionRow>
  );

  return (
    <>
      <Styled.Content>
        <Styled.AboutSection>
          <Styled.AboutDescription>
            <Text.H5>{t('intro.subheader1')}</Text.H5>
            <Text.P2>{t('intro.about1')}</Text.P2>
            <Text.P2>{t('intro.about2')}</Text.P2>
          </Styled.AboutDescription>
        </Styled.AboutSection>
        <Styled.InstructionSection>
          <Text.H5>{t('intro.subheader2')}</Text.H5>
          {instructionRows.map((row, key) => getRow(row, key))}
        </Styled.InstructionSection>
      </Styled.Content>
    </>
  );
}

export default IntroCard;
